import React from 'react';
import styled, { css } from 'styled-components';

import Input from 'antd/es/input';
import Switch from 'antd/es/switch';

const StyledInput = styled(Input)`
  max-width: 100px;
  width: 100px;

  // ${props => props.status && props.status === 'error' ? css`
  //   border-color: #F5222D;
  //   border-right-width: 1px !important;
  //   outline: 0;
  //   box-shadow: 0 0 0 2px #F5222D;
  // ` : null}
`;


function convertStringToNumber(stringValue, { min, max } = {}) {
  const value = Number(stringValue);

  if (min !== undefined && value < min) {
    return;
  }

  if (max !== undefined && value > max) {
    return;
  }

  return value;
}

function convertNumberToString(number) {
  return number === 0 || number > 0 ? number.toFixed(0) : '-' + number.toFixed(0);
}

const SettingInput = ({ type, value = null, onChange, ...rest }) => {
  switch (type) {
    case 'percentage': {
      const { min, max, ...extraProps } = rest;
      return (
        <StyledInput
          value={value !== null ? convertNumberToString(value * 100) : ''}
          onChange={e => {
            let val = null;

            if (e.target.value !== '') {
              const percent = convertStringToNumber(e.target.value, { min, max });
              if (percent === undefined || isNaN(percent)) {
                return;
              }
              val = percent / 100;
            }
            onChange && onChange(val);
          }}

          addonAfter="%"
          {...extraProps}
        />
      );
    }

    case 'number': {
      const { min, max, ...extraProps } = rest;
      return (
        <StyledInput
          value={value !== null ? value : ''}
          onChange={e => {
            let val = null;
            if (e.target.value !== '') {
              const num = convertStringToNumber(e.target.value, { min, max });
              if (num === undefined || isNaN(num)) {
                return;
              }
              val = num;
            }
            onChange && onChange(val, e);
          }}
          min={min}
          max={max}
          {...extraProps}
        />
      );
    };

    case 'switch':
      return (
        <Switch checked={value} onChange={onChange} />
      );

    default: {
      return (
        <StyledInput
          value={value}
          onChange={e => {
            let val = null;
            if (e.target.value !== '') {
              val = e.target.value;
            }
            onChange(val, e);
          }}
          {...rest}
        />
      );
    }
  }
};

export default SettingInput;
